<template>
	<div>
		<v-layout row>
			<v-flex xs1/>
			<v-flex xs3>
				<v-text-field
					browser-autocomplete="off"
					class="ma-2"
					v-model="dataTable.searchFields.projectCode"
					aria-label="project code"
					label="Nr projektu"
				></v-text-field>
			</v-flex>
			<v-flex xs4>
				<v-text-field
					browser-autocomplete="off"
					class="ma-2"
					v-model="dataTable.searchFields.projectTitle"
					aria-label="project title"
					label="Nazwa projektu"
				></v-text-field>
			</v-flex>
			<v-flex xs3>
				<v-autocomplete
					clearable
					class="ma-2"
					v-model="dataTable.searchFields.contestName"
					label="Nazwa konkursu"
					aria-label="contest name"
					:items="contestNameList"
				></v-autocomplete>
			</v-flex>
			<v-flex xs1/>
		</v-layout>
		<v-layout align-center justify-center row>
			<v-flex xs1/>
			<v-flex xs4>
				<v-autocomplete
					clearable
					class="ma-2"
					v-model="dataTable.searchFields.bidderName"
					label="Nazwa oferenta"
					aria-label="bidder name"
					:items="bidderNameList"
				></v-autocomplete>
			</v-flex>
			<v-flex xs6>
				<v-layout align-center justify-center>
					<v-btn @click="buildNewSearch" color="primary" dark class="ma-2">Szukaj</v-btn>
					<v-btn @click="resetSearch" color="primary" dark class="ma-2">Resetuj</v-btn>
					<v-btn @click="exportData" color="primary" dark class="ma-2">Eksportuj</v-btn>
				</v-layout>
			</v-flex>
			<v-flex xs1/>
		</v-layout>

		<v-data-table
			:headers="dataTable.headers"
			:rows-per-page-items="[10,20,25]"
			:items="dataTable.itemList"
			:pagination.sync="dataTable.pagination"
			:total-items="dataTable.itemCount"
			class="elevation-1">
			<template slot="items" slot-scope="props">
					<td>{{ props.item.projectCode }}</td>
					<td>{{ props.item.projectTitle }}</td>
					<td>{{ props.item.contestName }}</td>
					<td>
						<v-layout row>
							<v-flex shrink>
									{{ props.item.bidderName }}
							</v-flex>
							<v-flex v-if="props.item.mutualProject" pl-1 grow>
								<v-tooltip bottom>
									<template v-slot:activator="{ on }">
										<v-icon v-on="on">groups</v-icon>
									</template>
									<span>Projekt wspólny</span>
								</v-tooltip>
							</v-flex>
						</v-layout>
					</td>
			</template>
		</v-data-table>
	</div>
</template>

<script>
	import {Pagination} from "@/utils/PaginationUtils";
	import {Api} from "@/api";
	import {Offer} from "@/api/generated/Offer";
	import {ExportUtils} from "@/utils/ExportUtils";

	export default {
		name: "VolunteerProjectsTable",

		data () {
			return {
				contestNameList: [],
				bidderNameList: [],
				dataTable: {
					search: "",
					headers: [
						{text: "Nr projektu", value: "projectCode", align: "left", sortable: true},
						{text: "Nazwa projektu", value: "projectTitle", sortable: true},
						{text: "Nazwa konkursu", value: "contestName", sortable: true},
						{text: "Nazwa oferenta", value: "bidderName", sortable: true},
					],
					itemList: [],
					itemCount: 0,
					pagination: {
						rowsPerPage: 25,
						sortBy: null
					},
					searchFields: Pagination.initSearchedFields([
						'projectCode',
						'projectTitle',
						'contestName',
						'bidderName'
					]),
				}
			};
		},

		watch: {
			"dataTable.pagination": {
				handler () {
					this.getItemList();
				},
				deep: true,
			}
		},

		created () {
			this.getAllOffersContestNames();
			this.getAllOffersBidderNames();
		},

		computed: {
			pages () {
				// paginacja nie została zainicjalizowana
				if (this.dataTable.pagination.rowsPerPage === undefined) {
					return 0;
				}
				return Math.ceil(this.dataTable.itemCount / this.dataTable.pagination.rowsPerPage);
			},
		},

		methods: {
			getAllOffersContestNames () {
				Offer.getAllContestNames(this, false, successResponse => {
						this.contestNameList = successResponse;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować nazw konkursów", errorResponse);
					});
			},

			getAllOffersBidderNames () {
				Offer.getAllBidderNames(this, successResponse => {
						this.bidderNameList = successResponse;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować nazw oferentów", errorResponse);
					});
			},

			buildNewSearch () {
				this.dataTable.search = this.buildSearchCriteria();
				this.getItemList();
			},

			exportData () {
				let search = this.buildSearchCriteria();
				let sort = this.buildSort();
				let endpointMainPath = "projects";
				let path = "/" + endpointMainPath + "/export?search=" + search
					+ "&sort=".concat(sort);
				ExportUtils.sendExportRequest(path, this);
			},

			buildSearchCriteria () {
				return Pagination.buildSearchCriteria(this.dataTable.searchFields, false);
			},

			buildSort () {
				let order = this.dataTable.pagination.descending === true ? "desc" : "asc";
				let columnName = this.dataTable.pagination.sortBy;
				if (order && columnName) {
					return columnName.concat(" ").concat(order);
				} else {
					return "";
				}
			},

			resetSearch () {
				Pagination.resetSearch(this.dataTable.searchFields);
				this.buildNewSearch();
			},

			getItemList () {
				let sort = this.buildSort();
				Api.get(this,
					"/projects/list?search=" + this.dataTable.search
						+ "&page=" + this.dataTable.pagination.page
						+ "&result=" + this.dataTable.pagination.rowsPerPage
						+ "&sort=".concat(sort), response => {
							this.dataTable.itemList = response.itemList;
							this.dataTable.itemCount = response.itemCount;
						});
			},
		}
	};
</script>

<style scoped>

</style>
